jQuery(document).ready(function($) {
    const $carouselClients = $(".carousel-clients");
    if ( !$carouselClients.length )
        return;
	const carouselClients = $carouselClients.owlCarousel({
        items:5,
		mouseDrag: true,
		nav:true,
		dots: false,
		autoplay: true,
		autoplayHoverPause: false,
		autoplayTimeout: 4000,
		smartSpeed: 1500,
		loop: true,
		responsive : {
			// breakpoint xs
			320 : {
				items: 1     
			},
			// breakpoint sm
			769 : {
				items: 2
			},
			// breakpoint md
			1025 : {
				items: 3
			},
			// breakpoint lg
			1367 : {
				items: 4
			},
			// breakpoint xl
			1921 : {
				items: 5
			}
		  }
    });
}); 

jQuery(document).ready(function($) {
    const $carouselTestimonials = $(".carousel-testimonials");
    if ( !$carouselTestimonials.length )
        return;
	const carouselTestimonials = $carouselTestimonials.owlCarousel({
        items:1,
		mouseDrag: true,
		nav:true,
		dots: false,
		autoplay: false,
		autoplayHoverPause: false,
		autoplayTimeout: 4000,
		smartSpeed: 1500,
		loop: true,
		navText: [
			'<div aria-label="' + 'Previous' + '"><span class="icon-arrow-left"></span></div>',
			'<div aria-label="' + 'Next' + '"><span class="icon-arrow-right"></span></div>'
		]

    });
});